import modeReducer from "./modeReducer";
import { configureStore } from "@reduxjs/toolkit";

const store=configureStore({
    reducer:{
        mode:modeReducer
    }
});
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export default store;